// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// const UpdatedUserGroupsTable = ({
//   headers = [],
//   data = [],
//   searchPlaceholder,
//   dataClient,
//   setPagePath, // parent will receive an object with navigators
//   renderQuestionText,
//   selectedRows = [],
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);

//   // --- FORCED HIDE LIST (both prefixed and cleaned names) ---
//   const forcedHiddenColumns = [
//     "t*Client Branch ID",
//     "Client Branch ID",
//     "n*Group Owner User ID",
//     "Group Owner User ID",
//     "n*Ques Reviewer Group ID",
//     "Ques Reviewer Group ID",
//     "n*Course ID",
//     "Course ID",
//     "n*Subject ID",
//     "Subject ID",
//   ];

//   const idHeaderName = headers.find((h) => /User Group ID/i.test(String(h))) || "User Group ID";
//   const nameHeaderName = headers.find((h) => /User Group Name/i.test(String(h))) || "User Group Name";
//   const idIndex = headers.indexOf(idHeaderName);
//   const nameIndex = headers.indexOf(nameHeaderName);

//   // init visible columns - hide id header, ensure name first
//   useEffect(() => {
//     if (!headers || headers.length === 0) return;

//     // === MAKE YOUR DEFAULT VISIBLE COLUMNS HERE ===
//     const desiredDefaults = [
//       "User Group Name",
//       "User Group Description",
//       "Email Flag",
//       "Message Flag",
//       "Approved Flag",
//       "Status",
//     ];

//     // remove internal/id columns if accidentally included and forced hidden columns
//     const hideCols = new Set(["Role ID", idHeaderName, ...forcedHiddenColumns]);

//     // keep only those that actually exist in headers and are not hidden
//     const validDefaults = desiredDefaults.filter((h) => headers.includes(h) && !hideCols.has(h));

//     // If none of the desired defaults matched (defensive), fall back to previous behavior
//     if (validDefaults.length > 0) {
//       setVisibleColumns(validDefaults);
//       return;
//     }

//     // --- fallback to original behavior if desiredDefaults don't match ---
//     const cols = headers.filter((h) => h && !hideCols.has(h));
//     const otherCols = cols.filter((c) => c !== nameHeaderName);
//     const ordered = nameIndex !== -1 ? [nameHeaderName, ...otherCols] : cols;
//     const initial = ordered.slice(0, 5);
//     const mustHave = ["Role Code"];
//     const initialWithMustHave = headers.filter(
//       (h) => (mustHave.includes(h) || initial.includes(h)) && h !== "Role ID" && h !== idHeaderName
//     );
//     setVisibleColumns(initialWithMustHave.filter((c) => !hideCols.has(c)));
//   }, [headers, nameIndex, idHeaderName, nameHeaderName]);

//   const handleColumnSelection = (column) => {
//     if (["Role Code"].includes(column)) return;
//     setVisibleColumns((prev) => (prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]));
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const [filters, setFilters] = useState({});
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters });
//       setCurrentPage(1);
//       setIsFiltersApplied(true);
//       setIsFilterVisible(false);
//     }
//   };
//   const handleResetFilter = () => {
//     setFilters({});
//     setAppliedFilters({});
//     setAverageRunTime("");
//     setIsFiltersApplied(false);
//   };
//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prev) => ({ ...prev, [header]: selectedOption }));
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) => cell !== null && cell !== undefined && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime = averageRunTime === "" || row[2] === averageRunTime;
//     const matchesFilters = Object.entries(appliedFilters).every(([key, value]) => {
//       const colIndex = headers.indexOf(key);
//       return value ? row[colIndex] === value : true;
//     });
//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") direction = "desc";
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (columnDropdownRef.current && !columnDropdownRef.current.contains(event.target)) setIsColumnDivVisible(false);
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         const A = a[colIndex] === null || a[colIndex] === undefined ? "" : a[colIndex];
//         const B = b[colIndex] === null || b[colIndex] === undefined ? "" : b[colIndex];
//         if (A < B) return sortConfig.direction === "asc" ? -1 : 1;
//         if (A > B) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) => visibleColumns.map((column) => row[headers.indexOf(column)]));
//     const fileName = prompt("Enter the file name:");
//     if (!fileName) return;
//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType = type === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
//       const file = XLSX.write(workbook, { bookType: fileExtension, type: "array" });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({ head: [visibleColumns], body: exportData });
//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };
//   const handlePageChange = (page) => setCurrentPage(page);

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
//         pages.push(<span key="dots1">...</span>);
//         pages.push(<button key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>);
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(<button key={1} onClick={() => handlePageChange(1)}>1</button>);
//         pages.push(<span key="dots1">...</span>);
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
//         pages.push(<span key="dots2">...</span>);
//         pages.push(<button key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>);
//       } else {
//         pages.push(<button key={1} onClick={() => handlePageChange(1)}>1</button>);
//         pages.push(<span key="dots1">...</span>);
//         for (let i = totalPages - 2; i <= totalPages; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) return;
//     if (e.target.checked) setSelectedRows(data.map((row) => (idIndex !== -1 ? row[idIndex] : row[0])));
//     else setSelectedRows([]);
//   };

//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const row = sortedData[actualIndex];
//     const id = idIndex !== -1 ? row[idIndex] : row[0];
//     setSelectedRows((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [id]));
//   };

//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);
//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };
//   const handleMouseMove = (event) => {
//     if (isResizing.current && columnRef.current) {
//       const newWidth = Math.max(100, event.clientX - columnRef.current.offsetLeft);
//       setColumnWidth(newWidth);
//     }
//   };
//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   // Build navigators that push full selected rows + headers
//   const navigateToRoleAccessWithSelected = () => {
//     const selectedIds = Array.isArray(selectedRows) ? selectedRows : [];
//     const selectedRowsData = data.filter((row) => {
//       const idVal = idIndex !== -1 ? row[idIndex] : row[0];
//       return selectedIds.includes(idVal);
//     });
//     navigate("/user_group_role_access", { state: { selectedRowsData, headers } });
//   };

//   const navigateToManageEmployeeWithSelected = () => {
//     const selectedIds = Array.isArray(selectedRows) ? selectedRows : [];
//     const selectedRowsData = data.filter((row) => {
//       const idVal = idIndex !== -1 ? row[idIndex] : row[0];
//       return selectedIds.includes(idVal);
//     });
//     navigate("/manage_group_employee", { state: { selectedRowsData, headers } });
//   };

//   // Expose navigators to parent via setPagePath (if provided)
//   useEffect(() => {
//     if (typeof setPagePath === "function") {
//       // parent expects a setter; we call it with an object containing the functions
//       setPagePath({
//         toRoleAccess: navigateToRoleAccessWithSelected,
//         toManageEmployee: navigateToManageEmployeeWithSelected,
//       });
//       // cleanup: remove handlers on unmount
//       return () => {
//         try {
//           setPagePath(null);
//         } catch (e) {}
//       };
//     }
//     return undefined;
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedRows, data, headers, idIndex]);

//   return (
//     <div>
//       {/* top row: search and per-page controls */}
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px" }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "82vw" }}>
//           <div style={{ display: "flex", alignItems: "center", border: "1px solid #6A6A6A", overflow: "hidden" }}>
//             <input type="text" placeholder={searchPlaceholder} name="search" className="search-input-ques-dash" onChange={handleSearch} />
//             <div style={{ width: "1px", height: "24px", backgroundColor: "#2F2E40", margin: "0 4px" }} />
//             <img src={searchicon} alt="search" className="search-icon-ques-dash" />
//           </div>
//           <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
//             Displaying {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} - {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span key={size} onClick={() => handlePageSizeChange(Number(size))} style={{ cursor: "pointer", margin: "0 5px", textDecoration: size === pageSize.toString() ? "none" : "underline", color: size === pageSize.toString() ? "black" : "#337AB7" }}>
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* filter + column selection bar */}
//       <div style={{ display: "flex", backgroundColor: "#D6D6D6", marginTop: "9px", borderTop: "1px solid grey", borderBottom: "1px solid grey" }}>
//         <div style={{ backgroundColor: "#FFBD20", display: "flex", alignItems: "center", cursor: "pointer", paddingLeft: "8px", width: "90px" }} onClick={() => setIsFilterVisible(!isFilterVisible)}>
//           <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>

//         <div className="col-tc" style={{ marginLeft: "auto", textAlign: "end", marginRight: "8px", display: "flex", alignItems: "center", position: "relative", cursor: "pointer", height: "40px" }} onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}>
//           <img src={columnaddition} style={{ height: "34px", width: "32px" }} alt="column addition" />
//           <span style={{ marginLeft: "4px", color: "#2F2E40", marginRight: "14px", fontSize: "14px" }}>Column Selection</span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc" />
//               <div className="popupColumn-tc">
//                 {headers
//                   .filter((h) => h && h !== "Role ID" && h !== idHeaderName && !forcedHiddenColumns.includes(h))
//                   .map((column, index) => (
//                     <div key={index} onClick={(e) => { e.stopPropagation(); handleColumnSelection(column); }}>
//                       <input type="checkbox" id={`column-${index}`} value={column} className="square-checkbox-tc" checked={visibleColumns.includes(column)} disabled={column === "Role Code"} readOnly />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable">
//             <table className="fixed-header-table" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td key={index} ref={index === 0 ? columnRef : null} className={`Heading-tc resizable-header ${index === 0 ? "resizable-header" : ""}`} style={{ textAlign: "right", cursor: "pointer", width: index === 0 ? `${columnWidth}px` : "auto", position: "relative" }}>
//                       <span style={{ display: "flex", alignItems: "left", justifyContent: "left", color: "rgb(47, 46, 64)", fontSize: "14px" }}>
//                         {heading}
//                         {index === 0 && <div className="resize-handle" onMouseDown={handleMouseDown} />}
//                         <img onClick={() => handleSort(heading)} src={updown} style={{ height: "20px", width: "20px", marginLeft: "5px" }} alt="sort" />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
//                     {visibleColumns.map((column, cellIndex) => {
//                       const colIdx = headers.indexOf(column);
//                       const cellValue = row[colIdx];

//                       // first visible column (group name) => checkbox + hyperlink to details
//                       if (cellIndex === 0 && column === nameHeaderName) {
//                         const hiddenId = idIndex !== -1 ? row[idIndex] : row[0];
//                         return (
//                           <td key={cellIndex} style={{ width: cellIndex === 0 ? `${columnWidth}px` : "auto", textAlign: "left", color: "#6A6A6A", verticalAlign: "middle", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: `${columnWidth}px` }}>
//                             <div style={{ display: "flex", alignItems: "center" }}>
//                               <input type="checkbox" className="delete-question-checkbox-dqc" checked={selectedRows.includes(hiddenId)} onChange={() => handleRowSelect(rowIndex)} style={{ marginRight: "8px" }} />
//                               <a onClick={() => navigate("/user_group_details", { state: { rowData: row, headers } })} style={{ color: "#337ab7", cursor: "pointer", textDecoration: "none" }} title={String(cellValue)}>
//                                 <span className="truncated-text">{headers.indexOf(column) === 2 ? renderQuestionText?.(cellValue) : cellValue}</span>
//                               </a>
//                             </div>
//                           </td>
//                         );
//                       }

//                       // default rendering
//                       return (
//                         <td key={cellIndex} style={{ width: cellIndex === 0 ? `${columnWidth}px` : "auto", textAlign: "left", color: "#6A6A6A", verticalAlign: "middle", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: `${columnWidth}px` }}>
//                           <span className="truncated-text-2">{headers.indexOf(column) === 2 ? renderQuestionText?.(cellValue) : cellValue}</span>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="pagination-tc">
//             <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination"><img src={leftArrow} alt="" /></button>
//             <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="lefttc-pagination">{"<"}</button>
//             {renderPagination()}
//             <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="righttc-pagination">{">"}</button>
//             <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination"><img src={rightArrow} alt="" /></button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}

//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button className="repman-cross-btn-HOD" onClick={() => setIsFilterVisible(false)}><p>X</p></button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button className="create-test-section-btn" onClick={handleApplyFilter}>APPLY</button>
//               {isFiltersApplied && <button className="create-test-section-btn" onClick={handleResetFilter}>RESET</button>}
//             </div>

//             <div className="filter-options-container">
//               {headers
//                 .filter((h, index) => index !== 0 && !forcedHiddenColumns.includes(h))
//                 .map((header, filteredIndex) => {
//                   const originalIndex = headers.indexOf(header);
//                   let uniqueOptions = [...new Set(data.map((row) => row[originalIndex]).filter((option) => option))];
//                   if (originalIndex === 1 || originalIndex === 6) uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => handleFilterSelection(selectedOption, header)}
//                       options={uniqueOptions.map((value) => ({ label: value, id: value }))}
//                       selected={filters[header] || ""}
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UpdatedUserGroupsTable;

























import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const UpdatedUserGroupsTable = ({
  headers = [],
  data = [],
  searchPlaceholder,
  dataClient,
  setPagePath, // parent will receive an object with navigators
  renderQuestionText,
  selectedRows = [],
  setSelectedRows,
  bulk = false,
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const columnDropdownRef = useRef(null);

  // --- FORCED HIDE LIST (both prefixed and cleaned names) ---
  const forcedHiddenColumns = [
    "t*Client Branch ID",
    "Client Branch ID",
    "n*Group Owner User ID",
    "Group Owner User ID",
    "n*Ques Reviewer Group ID",
    "Ques Reviewer Group ID",
    "n*Course ID",
    "Course ID",
    "n*Subject ID",
    "Subject ID",
  ];

  const idHeaderName = headers.find((h) => /User Group ID/i.test(String(h))) || "User Group ID";
  const nameHeaderName = headers.find((h) => /User Group Name/i.test(String(h))) || "User Group Name";
  const idIndex = headers.indexOf(idHeaderName);
  const nameIndex = headers.indexOf(nameHeaderName);

  // init visible columns - hide id header, ensure name first
  useEffect(() => {
    if (!headers || headers.length === 0) return;

    // === MAKE YOUR DEFAULT VISIBLE COLUMNS HERE ===
    const desiredDefaults = [
      "User Group Name",
      "User Group Description",
      "Email Flag",
      "Message Flag",
      "Approved Flag",
      "Status",
    ];

    // remove internal/id columns if accidentally included and forced hidden columns
    const hideCols = new Set(["Role ID", idHeaderName, ...forcedHiddenColumns]);

    // keep only those that actually exist in headers and are not hidden
    const validDefaults = desiredDefaults.filter((h) => headers.includes(h) && !hideCols.has(h));

    // If none of the desired defaults matched (defensive), fall back to previous behavior
    if (validDefaults.length > 0) {
      setVisibleColumns(validDefaults);
      return;
    }

    // --- fallback to original behavior if desiredDefaults don't match ---
    const cols = headers.filter((h) => h && !hideCols.has(h));
    const otherCols = cols.filter((c) => c !== nameHeaderName);
    const ordered = nameIndex !== -1 ? [nameHeaderName, ...otherCols] : cols;
    const initial = ordered.slice(0, 5);
    const mustHave = ["Role Code"];
    const initialWithMustHave = headers.filter(
      (h) => (mustHave.includes(h) || initial.includes(h)) && h !== "Role ID" && h !== idHeaderName
    );
    setVisibleColumns(initialWithMustHave.filter((c) => !hideCols.has(c)));
  }, [headers, nameIndex, idHeaderName, nameHeaderName]);

  // -------------------------------
  // Minimal locking logic (no other layout changes)
  // Lock the first visible column so it cannot be deselected.
  // -------------------------------
  const lockedColumn = visibleColumns && visibleColumns.length > 0 ? visibleColumns[0] : headers[0];

  const handleColumnSelection = (column) => {
    // prevent toggling the locked column, and keep Role Code locked as before
    if (!column) return;
    if (column === lockedColumn) return;
    if (["Role Code"].includes(column)) return;
    setVisibleColumns((prev) => (prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]));
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters });
      setCurrentPage(1);
      setIsFiltersApplied(true);
      setIsFilterVisible(false);
    }
  };
  const handleResetFilter = () => {
    setFilters({});
    setAppliedFilters({});
    setAverageRunTime("");
    setIsFiltersApplied(false);
  };
  const handleFilterSelection = (selectedOption, header) => {
    setFilters((prev) => ({ ...prev, [header]: selectedOption }));
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) => cell !== null && cell !== undefined && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime = averageRunTime === "" || row[2] === averageRunTime;
    const matchesFilters = Object.entries(appliedFilters).every(([key, value]) => {
      const colIndex = headers.indexOf(key);
      return value ? row[colIndex] === value : true;
    });
    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") direction = "desc";
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (columnDropdownRef.current && !columnDropdownRef.current.contains(event.target)) setIsColumnDivVisible(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        const A = a[colIndex] === null || a[colIndex] === undefined ? "" : a[colIndex];
        const B = b[colIndex] === null || b[colIndex] === undefined ? "" : b[colIndex];
        if (A < B) return sortConfig.direction === "asc" ? -1 : 1;
        if (A > B) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) => visibleColumns.map((column) => row[headers.indexOf(column)]));
    const fileName = prompt("Enter the file name:");
    if (!fileName) return;
    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType = type === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const file = XLSX.write(workbook, { bookType: fileExtension, type: "array" });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({ head: [visibleColumns], body: exportData });
      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
        pages.push(<span key="dots1">...</span>);
        pages.push(<button key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>);
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(<button key={1} onClick={() => handlePageChange(1)}>1</button>);
        pages.push(<span key="dots1">...</span>);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
        pages.push(<span key="dots2">...</span>);
        pages.push(<button key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>);
      } else {
        pages.push(<button key={1} onClick={() => handlePageChange(1)}>1</button>);
        pages.push(<span key="dots1">...</span>);
        for (let i = totalPages - 2; i <= totalPages; i++) pages.push(<button key={i} onClick={() => handlePageChange(i)} className={i === currentPage ? "active" : ""}>{i}</button>);
      }
    }
    return pages;
  };

  const handleSelectAll = (e) => {
    if (!bulk) return;
    if (e.target.checked) setSelectedRows(data.map((row) => (idIndex !== -1 ? row[idIndex] : row[0])));
    else setSelectedRows([]);
  };

  const handleRowSelect = (rowIndex) => {
    const actualIndex = (currentPage - 1) * pageSize + rowIndex;
    const row = sortedData[actualIndex];
    const id = idIndex !== -1 ? row[idIndex] : row[0];
    setSelectedRows((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [id]));
  };

  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);
  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const handleMouseMove = (event) => {
    if (isResizing.current && columnRef.current) {
      const newWidth = Math.max(100, event.clientX - columnRef.current.offsetLeft);
      setColumnWidth(newWidth);
    }
  };
  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  // Build navigators that push full selected rows + headers
  const navigateToRoleAccessWithSelected = () => {
    const selectedIds = Array.isArray(selectedRows) ? selectedRows : [];
    const selectedRowsData = data.filter((row) => {
      const idVal = idIndex !== -1 ? row[idIndex] : row[0];
      return selectedIds.includes(idVal);
    });
    navigate("/user_group_role_access", { state: { selectedRowsData, headers } });
  };

  const navigateToManageEmployeeWithSelected = () => {
    const selectedIds = Array.isArray(selectedRows) ? selectedRows : [];
    const selectedRowsData = data.filter((row) => {
      const idVal = idIndex !== -1 ? row[idIndex] : row[0];
      return selectedIds.includes(idVal);
    });
    navigate("/manage_group_employee", { state: { selectedRowsData, headers } });
  };

  // Expose navigators to parent via setPagePath (if provided)
  useEffect(() => {
    if (typeof setPagePath === "function") {
      // parent expects a setter; we call it with an object containing the functions
      setPagePath({
        toRoleAccess: navigateToRoleAccessWithSelected,
        toManageEmployee: navigateToManageEmployeeWithSelected,
      });
      // cleanup: remove handlers on unmount
      return () => {
        try {
          setPagePath(null);
        } catch (e) {}
      };
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows, data, headers, idIndex]);

  return (
    <div>
      {/* top row: search and per-page controls */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "82vw" }}>
          <div style={{ display: "flex", alignItems: "center", border: "1px solid #6A6A6A", overflow: "hidden" }}>
            <input type="text" placeholder={searchPlaceholder} name="search" className="search-input-ques-dash" onChange={handleSearch} />
            <div style={{ width: "1px", height: "24px", backgroundColor: "#2F2E40", margin: "0 4px" }} />
            <img src={searchicon} alt="search" className="search-icon-ques-dash" />
          </div>
          <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
            Displaying {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} - {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span key={size} onClick={() => handlePageSizeChange(Number(size))} style={{ cursor: "pointer", margin: "0 5px", textDecoration: size === pageSize.toString() ? "none" : "underline", color: size === pageSize.toString() ? "black" : "#337AB7" }}>
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* filter + column selection bar */}
      <div style={{ display: "flex", backgroundColor: "#D6D6D6", marginTop: "9px", borderTop: "1px solid grey", borderBottom: "1px solid grey" }}>
        <div style={{ backgroundColor: "#FFBD20", display: "flex", alignItems: "center", cursor: "pointer", paddingLeft: "8px", width: "90px" }} onClick={() => setIsFilterVisible(!isFilterVisible)}>
          <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>

        <div className="col-tc" style={{ marginLeft: "auto", textAlign: "end", marginRight: "8px", display: "flex", alignItems: "center", position: "relative", cursor: "pointer", height: "40px" }} onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}>
          <img src={columnaddition} style={{ height: "34px", width: "32px" }} alt="column addition" />
          <span style={{ marginLeft: "4px", color: "#2F2E40", marginRight: "14px", fontSize: "14px" }}>Column Selection</span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc" />
              <div className="popupColumn-tc">
                {headers
                  .filter((h) => h && h !== "Role ID" && h !== idHeaderName && !forcedHiddenColumns.includes(h))
                  .map((column, index) => {
                    const isLocked = column === lockedColumn || column === "Role Code";

                    return (
                      <div key={index} onClick={(e) => { e.stopPropagation(); if (isLocked) return; handleColumnSelection(column); }}>
                        <input
                          type="checkbox"
                          id={`column-${index}`}
                          value={column}
                          className="square-checkbox-tc"
                          checked={visibleColumns.includes(column)}
                          disabled={isLocked}
                          readOnly
                        />
                        <label htmlFor={`column-${index}`}>{column}</label>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>

      {data.length > 0 ? (
        <>
          <div 
            className="table-container-scrollable"
            style={{
              width: "100%",
              // overflowX: "auto",      // <-- allow horizontal scroll inside table area only
              // overflowY: "visible",   // keep vertical behavior as before
              // WebkitOverflowScrolling: "touch",
              // boxSizing: "border-box" 
            }}
          >
            <div style={{ width: "82.2vw" }}>
              <table className="fixed-header-table" style={{ width: "100%", minWidth: "max-content" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td key={index} ref={index === 0 ? columnRef : null} className={`Heading-tc resizable-header ${index === 0 ? "resizable-header" : ""}`} style={{ textAlign: "right", cursor: "pointer", width: index === 0 ? `${columnWidth}px` : "auto", position: "relative" }}>
                      <span style={{ display: "flex", alignItems: "left", justifyContent: "left", color: "rgb(47, 46, 64)", fontSize: "14px" }}>
                        {heading}
                        {index === 0 && <div className="resize-handle" onMouseDown={handleMouseDown} />}
                        <img onClick={() => handleSort(heading)} src={updown} style={{ height: "20px", width: "20px", marginLeft: "5px" }} alt="sort" />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
                    {visibleColumns.map((column, cellIndex) => {
                      const colIdx = headers.indexOf(column);
                      const cellValue = row[colIdx];

                      // first visible column (group name) => checkbox + hyperlink to details
                      if (cellIndex === 0 && column === nameHeaderName) {
                        const hiddenId = idIndex !== -1 ? row[idIndex] : row[0];
                        return (
                          <td key={cellIndex} style={{ width: cellIndex === 0 ? `${columnWidth}px` : "auto", textAlign: "left", color: "#6A6A6A", verticalAlign: "middle", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: `${columnWidth}px` }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <input type="checkbox" className="delete-question-checkbox-dqc" checked={selectedRows.includes(hiddenId)} onChange={() => handleRowSelect(rowIndex)} style={{ marginRight: "8px" }} />
                              <a onClick={() => navigate("/user_group_details", { state: { rowData: row, headers } })} style={{ color: "#337ab7", cursor: "pointer", textDecoration: "none" }} title={String(cellValue)}>
                                <span className="truncated-text">{headers.indexOf(column) === 2 ? renderQuestionText?.(cellValue) : cellValue}</span>
                              </a>
                            </div>
                          </td>
                        );
                      }

                      // default rendering
                      return (
                        <td key={cellIndex} style={{ width: cellIndex === 0 ? `${columnWidth}px` : "auto", textAlign: "left", color: "#6A6A6A", verticalAlign: "middle", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: `${columnWidth}px` }}>
                          <span className="truncated-text-2">{headers.indexOf(column) === 2 ? renderQuestionText?.(cellValue) : cellValue}</span>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            
          </div>

          <div className="pagination-tc">
            <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination"><img src={leftArrow} alt="" /></button>
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="lefttc-pagination">{"<"}</button>
            {renderPagination()}
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="righttc-pagination">{">"}</button>
            <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination"><img src={rightArrow} alt="" /></button>
          </div>
        </>
      ) : (
        "No data available"
      )}

      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button className="repman-cross-btn-HOD" onClick={() => setIsFilterVisible(false)}><p>X</p></button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              <button className="create-test-section-btn" onClick={handleApplyFilter}>APPLY</button>
              {isFiltersApplied && <button className="create-test-section-btn" onClick={handleResetFilter}>RESET</button>}
            </div>

            <div className="filter-options-container">
              {headers
                .filter((h, index) => index !== 0 && !forcedHiddenColumns.includes(h))
                .map((header, filteredIndex) => {
                  const originalIndex = headers.indexOf(header);
                  let uniqueOptions = [...new Set(data.map((row) => row[originalIndex]).filter((option) => option))];
                  if (originalIndex === 1 || originalIndex === 6) uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => handleFilterSelection(selectedOption, header)}
                      options={uniqueOptions.map((value) => ({ label: value, id: value }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdatedUserGroupsTable;





